const Env = {
  install: function (Vue, options) {
    const env = Object.assign({}, process.env, options)
    console.debug('[plugin/env] installing ', JSON.stringify(env))
    Vue.$env = env
    Vue.prototype.$env = env
  }
}

export default Env



// WEBPACK FOOTER //
// ./src/plugins/env.js